"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDatabaseEngine = void 0;
const viewer_shared_global_access_objects_1 = require("@shapediver/viewer.shared.global-access-objects");
const MaterialDatabaseEngine_1 = require("./MaterialDatabaseEngine");
Object.defineProperty(exports, "MaterialDatabaseEngine", { enumerable: true, get: function () { return MaterialDatabaseEngine_1.MaterialDatabaseEngine; } });
const instance = MaterialDatabaseEngine_1.MaterialDatabaseEngine.instance;
viewer_shared_global_access_objects_1.GlobalAccessObjects.instance.assignMaterialFromDatabase =
    instance.assignMaterialFromDatabase.bind(instance);
//# sourceMappingURL=index.js.map